/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssignmentType,
  AutomationTokenId,
  CreateDistributionGroupRequest,
  CreateDistributionRequest,
  CreateDraftDistributionRequest,
  DistributionCycles,
  DistributionGroup,
  DistributionId,
  DistributionResponse,
  DistributionSnapshot,
  DraftWrappedConfigurationDTO,
  FairlyPrioritizedUsers,
  HistoricalConfigurationDTO,
  HistoricalLeaseViewRes,
  MapDistributionIdConfigurationWithExtraFieldsDTO,
  MapDistributionIdWrappedConfigurationDTO,
  MapOwnershipIdWrappedOwnershipState,
  MapString,
  OwnershipResponse,
  OwnershipSnapshot,
  PaginatedResultConfigurationDTO,
  ProductFeatureWithRoundRobin,
  PublishRequest,
  PublishedAndDraftDistributionDTO,
  RestoreFromSnapshotResponse,
  SnapshotsRequest,
  SnapshotsResponse,
  SwitchOwnershipTeamBulkRequest,
  UpdateDistributionRequest,
  UsageBulkRequestRes,
  UsageRequestRes,
  UsersOnVacationHandling,
  WorkspaceSettings,
  WorkspaceSettingsResponse,
  WrappedConfigurationDTO,
  WrappedDistributionGroup,
  WrappedDistributionState,
  WrappedLeaseRes,
  WrappedOwnershipState,
  WrappedWorkspaceSettings,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "distribution";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns list of available distributions
   *
   * @tags Queries
   * @name GetBulkListOfConfigurations
   * @request GET:/v1/tenant/{tenantId}/distribution
   * @secure
   */
  getBulkListOfConfigurations = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example "Record" */
      assignmentType?: AssignmentType;
      /**
       * v1 is old Distro distributions, v2 requires name when distribution is published
       * @format int32
       * @min 1
       * @max 2
       * @default 2
       * @example 1
       */
      version?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PublishedAndDraftDistributionDTO[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBulkListOfConfigurations */
  getBulkListOfConfigurationsPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example "Record" */
      assignmentType?: AssignmentType;
      /**
       * v1 is old Distro distributions, v2 requires name when distribution is published
       * @format int32
       * @min 1
       * @max 2
       * @default 2
       * @example 1
       */
      version?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution`, query);

  /**
   * @description Set round-robin kind (AvailabilityOptimised vs Strict), team and weights (default weight of 100% will be applied to not configured users)
   *
   * @tags CRUD/Distribution
   * @name CreateDistributionConfig
   * @request POST:/v1/tenant/{tenantId}/distribution
   * @secure
   */
  createDistributionConfig = (tenantId: string, data: CreateDistributionRequest, params: RequestParams = {}) =>
    this.request<
      WrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDistributionConfig */
  createDistributionConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/distribution`);

  /**
   * @description Returns list of available published distributions
   *
   * @tags Queries
   * @name GetBulkListOfPublishedConfigurations
   * @request GET:/v1/tenant/{tenantId}/distribution/published
   * @secure
   */
  getBulkListOfPublishedConfigurations = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example "Record" */
      assignmentType?: AssignmentType;
      /**
       * v1 is old Distro distributions, v2 requires name when distribution is published
       * @format int32
       * @min 1
       * @max 2
       * @default 2
       * @example 1
       */
      version?: number;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/published`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBulkListOfPublishedConfigurations */
  getBulkListOfPublishedConfigurationsPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example "Record" */
      assignmentType?: AssignmentType;
      /**
       * v1 is old Distro distributions, v2 requires name when distribution is published
       * @format int32
       * @min 1
       * @max 2
       * @default 2
       * @example 1
       */
      version?: number;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution/published`, query);

  /**
   * @description Returns everything about Distribution: draft, published, state and prediction
   *
   * @tags Queries
   * @name GetGatheredInfoOnDistribution
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/gathered
   * @secure
   */
  getGatheredInfoOnDistribution = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DistributionResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/gathered`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGatheredInfoOnDistribution */
  getGatheredInfoOnDistributionPathGetter = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/gathered`, query);

  /**
   * @description Returns gathered state of Ownership
   *
   * @tags Queries
   * @name GetGatheredInfoOnOwnership
   * @request GET:/v1/tenant/{tenantId}/ownership/{ownershipId}/gathered
   * @secure
   */
  getGatheredInfoOnOwnership = (tenantId: string, ownershipId: string, params: RequestParams = {}) =>
    this.request<
      OwnershipResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}/gathered`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGatheredInfoOnOwnership */
  getGatheredInfoOnOwnershipPathGetter = (tenantId: string, ownershipId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}/gathered`);

  /**
   * @description Returns list of users prioritized by their score from min to max
   *
   * @tags Queries
   * @name GetOrderedListOfUsers
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/users
   * @secure
   */
  getOrderedListOfUsers = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
      /** @default "MixIn" */
      vacationHandling?: UsersOnVacationHandling;
      /**
       * max number of returned results
       * @format int32
       * @min 1
       * @example 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      FairlyPrioritizedUsers,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrderedListOfUsers */
  getOrderedListOfUsersPathGetter = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
      /** @default "MixIn" */
      vacationHandling?: UsersOnVacationHandling;
      /**
       * max number of returned results
       * @format int32
       * @min 1
       * @example 10
       */
      limit?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/users`, query);

  /**
   * @description Create draft distribution from round-robin kind, team Id and weights (default weight of 100% will be applied to not configured users)
   *
   * @tags CRUD/Distribution/Draft
   * @name CreateDraftDistributionConfig
   * @request POST:/v1/tenant/{tenantId}/distribution/draft
   * @secure
   */
  createDraftDistributionConfig = (
    tenantId: string,
    data: CreateDraftDistributionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DraftWrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDraftDistributionConfig */
  createDraftDistributionConfigPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/draft`);

  /**
   * @description Returns draft Distribution configuration
   *
   * @tags CRUD/Distribution/Draft
   * @name GetDraftDistributionConfig
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/draft
   * @secure
   */
  getDraftDistributionConfig = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      DraftWrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/draft`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDraftDistributionConfig */
  getDraftDistributionConfigPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/draft`);

  /**
   * @description Create draft of config and set weights (default weight of 100% will be applied to not provided users)
   *
   * @tags CRUD/Distribution/Draft
   * @name UpdateDraftDistributionConfig
   * @request PUT:/v1/tenant/{tenantId}/distribution/{distributionId}/draft
   * @secure
   */
  updateDraftDistributionConfig = (
    tenantId: string,
    distributionId: string,
    data: UpdateDistributionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DraftWrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/draft`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateDraftDistributionConfig */
  updateDraftDistributionConfigPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/draft`);

  /**
   * @description Deletes selected draft of Round Robin distribution config and state
   *
   * @tags CRUD/Distribution/Draft
   * @name DeleteDraftRoundRobinDistribution
   * @request DELETE:/v1/tenant/{tenantId}/distribution/{distributionId}/draft
   * @secure
   */
  deleteDraftRoundRobinDistribution = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      DraftWrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/draft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteDraftRoundRobinDistribution */
  deleteDraftRoundRobinDistributionPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/draft`);

  /**
   * @description Duplicate draft and published configs of a distribution. Returns new distribution
   *
   * @tags CRUD/Distribution/Draft
   * @name DuplicateDistributionConfig
   * @request POST:/v1/tenant/{tenantId}/distribution/duplicate
   * @secure
   */
  duplicateDistributionConfig = (tenantId: string, data: DistributionId, params: RequestParams = {}) =>
    this.request<
      PublishedAndDraftDistributionDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/duplicate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for duplicateDistributionConfig */
  duplicateDistributionConfigPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/duplicate`);

  /**
   * @description Returns list of distribution configs available at selected timeframe. Latest config of distributions in [since, until] period is returned.
   *
   * @tags History
   * @name GetHistoricalDistributions
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/distribution-history
   * @secure
   */
  getHistoricalDistributions = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      HistoricalConfigurationDTO[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/distribution-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getHistoricalDistributions */
  getHistoricalDistributionsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/distribution-history`, query);

  /**
   * @description Returns list of distribution configs available at selected timeframe by workspace and Ids. Latest config of distributions in [since, until] period is returned. If `since` not provided - whole history is used for search. If `until` not provided, `now` is used.
   *
   * @tags History
   * @name GetHistoricalDistributionsByIdsPut
   * @request PUT:/v1/tenant/{tenantId}/distribution-history
   * @secure
   */
  getHistoricalDistributionsByIdsPut = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId?: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since?: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    data?: DistributionId[],
    params: RequestParams = {},
  ) =>
    this.request<
      HistoricalConfigurationDTO[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution-history`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getHistoricalDistributionsByIdsPut */
  getHistoricalDistributionsByIdsPutPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId?: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since?: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution-history`, query);

  /**
   * @description Returns Distribution configuration (metadata + weights)
   *
   * @tags CRUD/Distribution
   * @name GetDistributionConfig
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}
   * @secure
   */
  getDistributionConfig = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      WrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDistributionConfig */
  getDistributionConfigPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}`);

  /**
   * @description Update all possible distribution parameters: round-robin kind, team Id, calibration, weights of users (default weight of 100% will be applied to not configured users)
   *
   * @tags CRUD/Distribution
   * @name UpdateDistributionConfigsAndCalibration
   * @request PUT:/v1/tenant/{tenantId}/distribution/{distributionId}
   * @secure
   */
  updateDistributionConfigsAndCalibration = (
    tenantId: string,
    distributionId: string,
    data: UpdateDistributionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateDistributionConfigsAndCalibration */
  updateDistributionConfigsAndCalibrationPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}`);

  /**
   * @description Deletes published distribution and draft for it if exists
   *
   * @tags CRUD/Distribution
   * @name DeleteDistribution
   * @request DELETE:/v1/tenant/{tenantId}/distribution/{distributionId}
   * @secure
   */
  deleteDistribution = (
    tenantId: string,
    distributionId: string,
    query?: {
      /**
       * whether entity should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteDistribution */
  deleteDistributionPathGetter = (
    tenantId: string,
    distributionId: string,
    query?: {
      /**
       * whether entity should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}`, query);

  /**
   * @description Resets state of the distribution. After the action users in team won't have meetings history and Round Robin starts from beginning
   *
   * @tags CRUD/Distribution
   * @name ResetDistribution
   * @request PUT:/v1/tenant/{tenantId}/distribution/{distributionId}/reset
   * @secure
   */
  resetDistribution = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/reset`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resetDistribution */
  resetDistributionPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/reset`);

  /**
   * @description Returns Distribution configurations specified by ids (metadata + weights)
   *
   * @tags CRUD/Distribution
   * @name GetDistributionConfigBulkPut
   * @request PUT:/v1/tenant/{tenantId}/distribution-by-ids
   * @secure
   */
  getDistributionConfigBulkPut = (
    tenantId: string,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the distributions is missing
       * @default false
       */
      strict?: boolean;
    },
    data?: DistributionId[],
    params: RequestParams = {},
  ) =>
    this.request<
      MapDistributionIdWrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution-by-ids`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDistributionConfigBulkPut */
  getDistributionConfigBulkPutPathGetter = (
    tenantId: string,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the distributions is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution-by-ids`, query);

  /**
   * @description Returns Distribution configurations specified by ids (metadata + weights) with features where Distribution can be used
   *
   * @tags CRUD/Distribution
   * @name GetDistributionConfigAndAllowedFeaturesPerUserBulkPut
   * @request PUT:/v1/tenant/{tenantId}/distribution-with-extras-by-ids
   * @secure
   */
  getDistributionConfigAndAllowedFeaturesPerUserBulkPut = (
    tenantId: string,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the distributions is missing
       * @default false
       */
      strict?: boolean;
    },
    data?: DistributionId[],
    params: RequestParams = {},
  ) =>
    this.request<
      MapDistributionIdConfigurationWithExtraFieldsDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution-with-extras-by-ids`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDistributionConfigAndAllowedFeaturesPerUserBulkPut */
  getDistributionConfigAndAllowedFeaturesPerUserBulkPutPathGetter = (
    tenantId: string,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the distributions is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/distribution-with-extras-by-ids`, query);

  /**
   * @description Returns list of users with their statistics aggregated from events
   *
   * @tags CRUD/Distribution
   * @name GetCurrentStatisticsOfTheDistributionGroup
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/state
   * @secure
   */
  getCurrentStatisticsOfTheDistributionGroup = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/state`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCurrentStatisticsOfTheDistributionGroup */
  getCurrentStatisticsOfTheDistributionGroupPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/state`);

  /**
   * @description Resets state of distributions whithin specified workspace. After the action users in team won't have meetings history and Round Robin starts from beginning.
   *
   * @tags CRUD/Distribution
   * @name ResetDistributionByWorkspace
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/reset
   * @secure
   */
  resetDistributionByWorkspace = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionState[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reset`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resetDistributionByWorkspace */
  resetDistributionByWorkspacePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reset`);

  /**
   * @description Drops credit/skip configs of distributions whithin specified workspace.
   *
   * @tags CRUD/Distribution
   * @name ResetCreditSkipByWorkspace
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/reset/manual-calibration
   * @secure
   */
  resetCreditSkipByWorkspace = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionState[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reset/manual-calibration`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resetCreditSkipByWorkspace */
  resetCreditSkipByWorkspacePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reset/manual-calibration`);

  /**
   * @description Publishes selected distribution. If it's already published - no change. If ResetFlag provided - do reset
   *
   * @tags CRUD/Distribution
   * @name PublishDistributionConfiguration
   * @request PUT:/v1/tenant/{tenantId}/distribution/{distributionId}/publish
   * @secure
   */
  publishDistributionConfiguration = (
    tenantId: string,
    distributionId: string,
    data?: PublishRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedConfigurationDTO,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/publish`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishDistributionConfiguration */
  publishDistributionConfigurationPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/publish`);

  /**
   * @description Update Draft Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name UpdateDraftWorkspaceSettings
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/draft
   * @secure
   */
  updateDraftWorkspaceSettings = (
    tenantId: string,
    workspaceId: string,
    data: WorkspaceSettings,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedWorkspaceSettings,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateDraftWorkspaceSettings */
  updateDraftWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`);

  /**
   * @description Create/Update Draft Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name CreateDraftWorkspaceSettings
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/draft
   * @secure
   */
  createDraftWorkspaceSettings = (
    tenantId: string,
    workspaceId: string,
    data: WorkspaceSettings,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedWorkspaceSettings,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDraftWorkspaceSettings */
  createDraftWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`);

  /**
   * @description Delete draft Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name DeleteDraftWorkspaceSettings
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/draft
   * @secure
   */
  deleteDraftWorkspaceSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WrappedWorkspaceSettings,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteDraftWorkspaceSettings */
  deleteDraftWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/draft`);

  /**
   * @description Returns Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name GetWorkspaceSettings
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  getWorkspaceSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WorkspaceSettingsResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceSettings */
  getWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);

  /**
   * @description Publish Workspace Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name PublishWorkspaceSettings
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  publishWorkspaceSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WrappedWorkspaceSettings,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishWorkspaceSettings */
  publishWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);

  /**
   * @description Delete published Workspace distribution Settings
   *
   * @tags CRUD/WorkspaceSettingsV3
   * @name DeleteWorkspaceSettings
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  deleteWorkspaceSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WrappedWorkspaceSettings,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWorkspaceSettings */
  deleteWorkspaceSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);

  /**
   * @description Returns Ownership state
   *
   * @tags CRUD/Ownership
   * @name GetOwnershipState
   * @request GET:/v1/tenant/{tenantId}/ownership/{ownershipId}
   * @secure
   */
  getOwnershipState = (tenantId: string, ownershipId: string, params: RequestParams = {}) =>
    this.request<
      WrappedOwnershipState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOwnershipState */
  getOwnershipStatePathGetter = (tenantId: string, ownershipId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}`);

  /**
   * @description Resets Ownership state and possibly changes team
   *
   * @tags CRUD/Ownership
   * @name ResetOwnershipState
   * @request POST:/v1/tenant/{tenantId}/ownership/{ownershipId}
   */
  resetOwnershipState = (
    tenantId: string,
    ownershipId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "someTeamId"
       */
      teamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedOwnershipState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resetOwnershipState */
  resetOwnershipStatePathGetter = (
    tenantId: string,
    ownershipId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "someTeamId"
       */
      teamId?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}`, query);

  /**
   * @description Returns Ownership states specified by ids
   *
   * @tags CRUD/Ownership
   * @name GetOwnershipStatesBulk
   * @request GET:/v1/tenant/{tenantId}/ownership-by-ids
   * @secure
   */
  getOwnershipStatesBulk = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @example ["a5sd43a5d4a3da5d5ad45ad4asd","dasf567a34sd6as54fas67d5f4as"]
       */
      ids?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapOwnershipIdWrappedOwnershipState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOwnershipStatesBulk */
  getOwnershipStatesBulkPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @example ["a5sd43a5d4a3da5d5ad45ad4asd","dasf567a34sd6as54fas67d5f4as"]
       */
      ids?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ownership-by-ids`, query);

  /**
   * @description Resets Ownership state
   *
   * @tags Internal/CRUD/Ownership
   * @name InternalResetOwnershipStateSwitchTeam
   * @request POST:/v1/tenant/{tenantId}/ownership/{ownershipId}/reset
   */
  internalResetOwnershipStateSwitchTeam = (tenantId: string, ownershipId: string, params: RequestParams = {}) =>
    this.request<
      WrappedOwnershipState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}/reset`,
      method: "POST",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for internalResetOwnershipStateSwitchTeam */
  internalResetOwnershipStateSwitchTeamPathGetter = (tenantId: string, ownershipId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}/reset`);

  /**
   * @description Switch team in Ownership state. Idempotent, i.e. reset happens only if team was switched
   *
   * @tags Internal/CRUD/Ownership
   * @name InternalSwitchTeamInOwnershipState
   * @request PUT:/v1/tenant/{tenantId}/ownership/{ownershipId}/switch-team/{teamId}
   */
  internalSwitchTeamInOwnershipState = (
    tenantId: string,
    ownershipId: string,
    teamId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedOwnershipState,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}/switch-team/${teamId}`,
      method: "PUT",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for internalSwitchTeamInOwnershipState */
  internalSwitchTeamInOwnershipStatePathGetter = (tenantId: string, ownershipId: string, teamId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}/switch-team/${teamId}`);

  /**
   * @description Resets Ownership state and changes teams bulk. Idempotent, i.e. reset happens only if team was switched. Returns only entities with switched teams
   *
   * @tags Internal/CRUD/Ownership
   * @name InternalSwitchTeamInOwnershipBulkReset
   * @request PUT:/v1/tenant/{tenantId}/ownership/switch-team
   */
  internalSwitchTeamInOwnershipBulkReset = (
    tenantId: string,
    data: SwitchOwnershipTeamBulkRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedOwnershipState[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/switch-team`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for internalSwitchTeamInOwnershipBulkReset */
  internalSwitchTeamInOwnershipBulkResetPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/switch-team`);

  /**
   * @description Returns Distribution and Ownership snapshots specified by ids
   *
   * @tags CRUD/Snapshots
   * @name GetSnapshotsBulk
   * @request PUT:/v1/tenant/{tenantId}/snapshot-by-ids
   * @secure
   */
  getSnapshotsBulk = (tenantId: string, data: SnapshotsRequest, params: RequestParams = {}) =>
    this.request<
      SnapshotsResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/snapshot-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSnapshotsBulk */
  getSnapshotsBulkPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/snapshot-by-ids`);

  /**
   * @description Returns Ownership snapshot specified by id and timestamp
   *
   * @tags CRUD/Snapshots
   * @name GetOwnershipSnapshot
   * @request GET:/v1/tenant/{tenantId}/ownership/{ownershipId}/snapshot/{timestamp}
   * @secure
   */
  getOwnershipSnapshot = (tenantId: string, ownershipId: string, timestamp: string, params: RequestParams = {}) =>
    this.request<
      OwnershipSnapshot,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ownership/${ownershipId}/snapshot/${timestamp}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOwnershipSnapshot */
  getOwnershipSnapshotPathGetter = (tenantId: string, ownershipId: string, timestamp: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/ownership/${ownershipId}/snapshot/${timestamp}`);

  /**
   * @description Returns Distribution snapshot specified by id and timestamp
   *
   * @tags CRUD/Snapshots
   * @name GetDistributionSnapshot
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/snapshot/{timestamp}
   * @secure
   */
  getDistributionSnapshot = (tenantId: string, distributionId: string, timestamp: string, params: RequestParams = {}) =>
    this.request<
      DistributionSnapshot,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/snapshot/${timestamp}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDistributionSnapshot */
  getDistributionSnapshotPathGetter = (tenantId: string, distributionId: string, timestamp: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/snapshot/${timestamp}`);

  /**
   * @description Returns Distribution cycles specified by id
   *
   * @tags CRUD/Snapshots
   * @name GetDistributionCycles
   * @request GET:/v1/tenant/{tenantId}/distribution/{distributionId}/cycles
   * @secure
   */
  getDistributionCycles = (tenantId: string, distributionId: string, params: RequestParams = {}) =>
    this.request<
      DistributionCycles,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/distribution/${distributionId}/cycles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDistributionCycles */
  getDistributionCyclesPathGetter = (tenantId: string, distributionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/distribution/${distributionId}/cycles`);

  /**
   * @description Restores deleted distribution or ownership based on latest snapshot
   *
   * @tags CRUD/Snapshots
   * @name RestoreDeletedDistributionOrOwnership
   * @request POST:/v1/tenant/{tenantId}/restore-from-snapshot
   * @secure
   */
  restoreDeletedDistributionOrOwnership = (tenantId: string, data: SnapshotsRequest, params: RequestParams = {}) =>
    this.request<
      RestoreFromSnapshotResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/restore-from-snapshot`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for restoreDeletedDistributionOrOwnership */
  restoreDeletedDistributionOrOwnershipPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/restore-from-snapshot`);

  /**
   * @description Public endpoint: Returns list of users prioritized by their score from min to max
   *
   * @tags Public
   * @name PublicGetOrderedListOfUsers
   * @request GET:/v1/public/tenant/{tenantId}/distribution/{distributionId}/users
   */
  publicGetOrderedListOfUsers = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
      /** @default "MixIn" */
      vacationHandling?: UsersOnVacationHandling;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      FairlyPrioritizedUsers,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/distribution/${distributionId}/users`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicGetOrderedListOfUsers */
  publicGetOrderedListOfUsersPathGetter = (
    tenantId: string,
    distributionId: string,
    query?: {
      /** @example "DistroRouter" */
      productFeature?: ProductFeatureWithRoundRobin;
      /** @default "MixIn" */
      vacationHandling?: UsersOnVacationHandling;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/distribution/${distributionId}/users`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);

  /**
   * No description
   *
   * @tags Lease
   * @name ListResourcesWhichUsedThisResourceDuringTimePeriodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-historical
   * @secure
   */
  listResourcesWhichUsedThisResourceDuringTimePeriodPut = (
    tenantId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    data: UsageRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      HistoricalLeaseViewRes[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-historical`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUsedThisResourceDuringTimePeriodPut */
  listResourcesWhichUsedThisResourceDuringTimePeriodPutPathGetter = (
    tenantId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/lease-historical`, query);

  /**
   * No description
   *
   * @tags Lease
   * @name ListResourcesWhichUsedQueriedResourcesDuringTimePeriodPutBulkQuery
   * @request PUT:/v1/tenant/{tenantId}/lease-historical-by-ids
   * @secure
   */
  listResourcesWhichUsedQueriedResourcesDuringTimePeriodPutBulkQuery = (
    tenantId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      HistoricalLeaseViewRes[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-historical-by-ids`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUsedQueriedResourcesDuringTimePeriodPutBulkQuery */
  listResourcesWhichUsedQueriedResourcesDuringTimePeriodPutBulkQueryPathGetter = (
    tenantId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/lease-historical-by-ids`, query);

  /**
   * @description Get by workspace distribution groups
   *
   * @tags Groups
   * @name GetBulkGroups
   * @request GET:/v1/tenant/{tenantId}/groups
   * @secure
   */
  getBulkGroups = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedDistributionGroup[],
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/groups`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBulkGroups */
  getBulkGroupsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/groups`, query);

  /**
   * @description Create distribution groups
   *
   * @tags Groups
   * @name CreateGroups
   * @request PUT:/v1/tenant/{tenantId}/groups
   * @secure
   */
  createGroups = (tenantId: string, data: CreateDistributionGroupRequest, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionGroup,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/groups`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createGroups */
  createGroupsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/groups`);

  /**
   * @description Get distribution groups
   *
   * @tags Groups
   * @name GetGroups
   * @request GET:/v1/tenant/{tenantId}/groups/{groupId}
   * @secure
   */
  getGroups = (tenantId: string, groupId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionGroup,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/groups/${groupId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGroups */
  getGroupsPathGetter = (tenantId: string, groupId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/groups/${groupId}`);

  /**
   * @description Update distribution groups
   *
   * @tags Groups
   * @name UpdateGroups
   * @request PUT:/v1/tenant/{tenantId}/groups/{groupId}
   * @secure
   */
  updateGroups = (tenantId: string, groupId: string, data: DistributionGroup, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionGroup,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/groups/${groupId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateGroups */
  updateGroupsPathGetter = (tenantId: string, groupId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/groups/${groupId}`);

  /**
   * @description Delete distribution groups
   *
   * @tags Groups
   * @name DeleteGroups
   * @request DELETE:/v1/tenant/{tenantId}/groups/{groupId}
   * @secure
   */
  deleteGroups = (tenantId: string, groupId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDistributionGroup,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/groups/${groupId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteGroups */
  deleteGroupsPathGetter = (tenantId: string, groupId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/groups/${groupId}`);
}
